import axios from 'axios';
import { setupAxiosInterceptor } from './auth/axiosConfig';
import config from './config';

const supportApi = axios.create({
  baseURL: config.API_BASE_URL + '/cellcog',
});
setupAxiosInterceptor(supportApi);

export const listSupportDocs = () =>
  supportApi.get('/support/docs');

// Backend API fetch (fallback): serves md/cellcog/customer_support/* at runtime.
export const getSupportDocFromApi = (filename) =>
  supportApi.get(`/support/docs/${encodeURIComponent(filename)}`, {
    // Return raw text, not parsed JSON
    transformResponse: [(data) => data],
  });

// Static-first fetch (CEL-672 SEO fix): the build copies the guides into
// public/support-docs/ (see scripts/copySupportDocs.js), so the deployed app —
// and react-snap at prerender time, when the backend is NOT running — can load
// guide content without the API. Falls back to the API when the static copy is
// missing (e.g. `npm start` dev server without a prior build).
// NOTE: CRA's dev/prod servers answer unknown paths with index.html (HTTP 200),
// so a missing static file comes back as an HTML shell, not a 404 — detect that
// and treat it as a miss.
export const getSupportDoc = async (filename) => {
  try {
    const res = await axios.get(`/support-docs/${encodeURIComponent(filename)}`, {
      transformResponse: [(data) => data],
    });
    const body = typeof res.data === 'string' ? res.data : '';
    const looksLikeHtmlShell = /^\s*<(!doctype|html)/i.test(body);
    if (!looksLikeHtmlShell) return res;
  } catch (e) {
    // fall through to API fallback
  }
  return getSupportDocFromApi(filename);
};

export default supportApi;
